<template>
    <div class="newsdetails">
        <div class="box_1 flex-col">
          <div class="p_img">
            <a href="javascript:;">
              <img src="@/assets/client/banner_6.jpg" alt="新闻资讯" title="新闻资讯">
            </a>
          </div>
          <div class="p_info">
            <div>
              <h2 class="text-white p_btitle">新闻资讯</h2>
              <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
            </div>
          </div>
          </div>
          <div class="box_5 flex-col">
            <div class="box_6 flex-row">
              <div class="text-wrapper_1 flex-col justify-between">
                <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;新闻动态</span>
                <span class="text_14">{{modelitemName}}</span>
              </div>
              <div class="box_7 flex-row justify-between">
                <div class="text-wrapper_2 flex-col" @click="setState('NT01')"   :style="{'background-color':form.modelitem=='NT01'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_15" :style="{'color':form.modelitem=='NT01'?'white':'rgba(0, 90, 214, 1)'}">公司动态</span>
                </div>
                <div class="text-wrapper_3 flex-col" @click="setState('NT02')"  :style="{'background-color':form.modelitem=='NT02'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_16"  :style="{'color':form.modelitem=='NT02'?'white':'rgba(0, 90, 214, 1)'}">媒体关注</span>
                </div>
                <div class="text-wrapper_4 flex-col" @click="setState('NT03')" :style="{'background-color':form.modelitem=='NT03'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_17"  :style="{'color':form.modelitem=='NT03'?'white':'rgba(0, 90, 214, 1)'}">行业新闻</span>
                </div>
                <div class="text-wrapper_5 flex-col" @click="setState('NT04')" :style="{'background-color':form.modelitem=='NT04'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_18" :style="{'color':form.modelitem=='NT04'?'white':'rgba(0, 90, 214, 1)'}">影像先河</span>
                </div>
              </div>
              <div class="text-wrapper_6_be" >
                <transition  name="slide">
                  <div class="text-wrapper_6 flex-col" v-if="telshow">
                    <span class="text_19">4001-300-137</span>
                  </div>
                </transition>
              </div>
              <div class="box_8_1">
                <div class="box_8 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                  <div class="image-text_1 flex-col justify-between">
                    <img
                      class="label_1"
                      referrerpolicy="no-referrer"
                      src="@/assets/client/tel.png"
                    />
                    <span class="text-group_1">业务咨询</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="image-wrapper_1 flex-row">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/client/xwzxbg.png"
              />
            </div>
            <div style="text-align: center;margin-top: 1.77vw;">
              <span class="text_20"
              >{{detailInfo.news_title}}</span>
            </div>
          <div class="box_8_2 flex-row justify-between">
            <div class="text-wrapper_7">
              <span class="text_21">分类：</span>
              <span class="text_22">{{detailInfo.newsmodelType}}</span>
              <span class="text_23">编辑：</span>
                <span class="text_22">{{detailInfo.news_author}}</span>
                 <span class="text_24">来源：</span>
                 <span class="text_22">{{detailInfo.news_source}}</span>
                <span class="text_25">发布时间：</span>
                <span class="text_22">{{detailInfo.publishdate}}</span>
            </div>
          </div>
          <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="@/assets/client/underline.png"
      />
      <div
      class="html-div"
      style="width:72.97vw;height:auto;margin: 1.66vw 0 0 13.54vw;padding:20px;box-sizing:border-box;"
      v-html="detailInfo.news_content"
      ></div>
      <div  style="height:100px;margin-left:13.54vw ;">
        <div v-if="filesFlag" style="font-size: 1vw">附件：</div>
            <AttachmentList
            @AttachmentList="AttachmentList"
            ref="fileList1"
            :objectID="uploadForm.objectID"
            :UseType="uploadForm.UseType"
            :TableName="uploadForm.TableName"
            :ShowDelete="false"
            >
            </AttachmentList>
        </div>
      <div class="box_9 flex-col"></div>
      <div class="box_10 flex-row justify-between">
        <div class="text-wrapper_11">
          <div v-if="detailInfo.previous_id!=''">
            <span class="text_33">上一篇：</span>
            <span class="text_34" @click="toNews('previous')"
              >{{detailInfo.previous_title}}</span
            >
          </div>
        </div>
        <div class="text-wrapper_12">
          <div  v-if="detailInfo.next_id!=''">
            <span class="text_36">下一篇:</span>
            <span class="text_35"  @click="toNews('next')">{{detailInfo.next_title}}&nbsp;</span>
          </div>
        </div>
      </div>
          </div>

          <!-- 移动端新闻详情页 -->
          <div class="mobile-news-detail">
            <!-- 返回导航栏 -->
            <div class="mobile-news-detail-navbar">
              <div class="mobile-news-detail-navbar__back" @click="backToList">
                <span class="mobile-news-detail-navbar__back-icon el-icon-arrow-left"></span>
                <span>返回</span>
              </div>
              <h1 class="mobile-news-detail-navbar__title">{{ modelitemName }}</h1>
            </div>

            <!-- 详情内容 -->
            <div class="mobile-news-detail-content">
              <!-- 新闻标题和元信息 -->
              <div class="mobile-news-detail-header">
                <h2 class="mobile-news-detail-header__title">{{ detailInfo.news_title }}</h2>
                <div class="mobile-news-detail-header__meta">
                  <div class="mobile-news-detail-header__meta-item">
                    <span class="mobile-news-detail-header__meta-label">分类：</span>
                    <span class="mobile-news-detail-header__meta-value">{{ detailInfo.newsmodelType }}</span>
                  </div>
                  <div class="mobile-news-detail-header__meta-item">
                    <span class="mobile-news-detail-header__meta-label">编辑：</span>
                    <span class="mobile-news-detail-header__meta-value">{{ detailInfo.news_author }}</span>
                  </div>
                  <div class="mobile-news-detail-header__meta-item">
                    <span class="mobile-news-detail-header__meta-label">来源：</span>
                    <span class="mobile-news-detail-header__meta-value">{{ detailInfo.news_source }}</span>
                  </div>
                  <div class="mobile-news-detail-header__meta-item">
                    <span class="mobile-news-detail-header__meta-label">发布时间：</span>
                    <span class="mobile-news-detail-header__meta-value">{{ detailInfo.publishdate }}</span>
                  </div>
                </div>
              </div>

              <!-- 新闻正文 -->
              <div class="mobile-news-detail-body">
                <div class="mobile-news-detail-body__content" v-html="detailInfo.news_content"></div>
              </div>

              <!-- 附件 -->
              <div v-if="filesFlag" class="mobile-news-detail-attachments">
                <h3 class="mobile-news-detail-attachments__title">附件：</h3>
                <AttachmentList
                  @AttachmentList="AttachmentList"
                  ref="fileList1"
                  :objectID="uploadForm.objectID"
                  :UseType="uploadForm.UseType"
                  :TableName="uploadForm.TableName"
                  :ShowDelete="false"
                >
                </AttachmentList>
              </div>

              <!-- 上一篇/下一篇导航 -->
              <div class="mobile-news-detail-navigation">
                <div 
                  v-if="detailInfo.previous_id!=''" 
                  class="mobile-news-detail-navigation__item"
                  @click="toNews('previous')"
                >
                  <div class="mobile-news-detail-navigation__label">上一篇</div>
                  <div class="mobile-news-detail-navigation__title">{{ detailInfo.previous_title }}</div>
                </div>
                <div v-else class="mobile-news-detail-navigation__item">
                  <div class="mobile-news-detail-navigation__label">上一篇</div>
                  <div class="mobile-news-detail-navigation__empty">没有了</div>
                </div>

                <div 
                  v-if="detailInfo.next_id!=''" 
                  class="mobile-news-detail-navigation__item"
                  @click="toNews('next')"
                >
                  <div class="mobile-news-detail-navigation__label">下一篇</div>
                  <div class="mobile-news-detail-navigation__title">{{ detailInfo.next_title }}</div>
                </div>
                <div v-else class="mobile-news-detail-navigation__item">
                  <div class="mobile-news-detail-navigation__label">下一篇</div>
                  <div class="mobile-news-detail-navigation__empty">没有了</div>
                </div>
              </div>
            </div>
          </div>

    </div>
</template>
<script>
  import AttachmentList from "@/components/AttachmentList";
    export default{
      components: {AttachmentList },
        data(){
            return{
                detailInfo:{},
                form:{
                    id:"",
                    modelitem:"NT01",
                    newsmodel:"NewsType"
                },
                uploadForm: {
                  objectID: "",
                  UseType: 0,
                  TableName: "t_news_main",
                },
                modelitemName:"公司动态",
                filesFlag:false,
                detailInfo: {},
                loading:false,
                telshow:false,
                // 移动端相关数据
                isMobile: false,
            }
        },
        methods:{
            setState(state){
                let that = this;
                that.form.modelitem = state;
                that.$router.push({
                    path: "/Client/NewsTrends",
                    name:"ClientNewsTrends",
                    params: {
                    modelitem:this.form.modelitem,
                    newsmodel:this.form.newsmodel
                },
              });
            },
            selectNews()
            {
              let that = this;
                that.$api.post("/Client/getNewsDetails", that.form,
                    function (res) {
                        if (res.code === "200") {
                            that.detailInfo=res.data;
                            that.uploadForm.objectID = res.data.id;
                            that.$nextTick(() => {
                              that.$refs.fileList1.GetAttachmentList();
                            });
                            that.loading = false;

                        }
                    },
                    function (res) {
                        that.$message.error("服务异常，信息出错");
                    }
                );
            },
            toNews(type)
            {
              let that = this;
              if(type=='previous'){
                if(that.detailInfo.previous_is_open_attachment=="1"){
                  window.open(process.env.VUE_APP_FileAddress.replace('fileapi/', '')+that.detailInfo.previous_FilePath, '_blank');
                } else if (that.detailInfo.previous_is_open_url=="1"){
                  window.open(that.detailInfo.previous_url, '_blank');
                }else{
                  that.form.id = that.detailInfo.previous_id;
                  that.selectNews();
                }

              }else{
                if(that.detailInfo.next_is_open_attachment=="1"){
                  window.open(process.env.VUE_APP_FileAddress.replace('fileapi/', '')+that.detailInfo.next_FilePath, '_blank');
                } else if (that.detailInfo.next_is_open_url=="1"){
                  window.open(that.detailInfo.next_url, '_blank');
                }else{
                  that.form.id = that.detailInfo.next_id;
                  that.selectNews();
                }
              }
            },
            AttachmentList(files,objid){
                if(files !=null && files.length>0){
                    this.filesFlag=true;
                }
            },
            handleMouseEnter(){
            let that = this;
            that.telshow = true;
          },
          handleMouseLeave(){
            let that = this;
            that.telshow = false;
          },
          // 移动端相关方法
          checkMobile() {
            this.isMobile = window.innerWidth <= 768;
          },
          backToList() {
            // 返回新闻列表页
            this.$router.push({
              path: "/Client/NewsTrends",
              query: { type: this.form.modelitem }
            });
          },
        },
        mounted(){
            let that = this;
            that.loading = true;
            that.form.id=this.$route.query.id;
            that.form.modelitem = this.$route.query.modelitem;
            that.form.newsmodel = this.$route.query.newsmodel;
            if(this.$route.query.modelitem=='NT01'){
              that.modelitemName ="公司动态";
            }
            if(this.$route.query.modelitem=='NT02'){
              that.modelitemName ='媒体关注';
            }
            if(this.$route.query.modelitem=='NT03'){
              that.modelitemName ='行业新闻';
            }
            if(this.$route.query.modelitem=='NT04'){
              that.modelitemName ='影像先河';
            }
            that.selectNews();
            // 移动端检测
            that.checkMobile();
            window.addEventListener('resize', that.checkMobile);
        },
        beforeDestroy() {
          // 移除事件监听
          window.removeEventListener('resize', this.checkMobile);
        },
    }
</script>
<style scoped>
    @import '../../../assets/client/newsdetails.css';
    @import '../../../assets/client/newstrends-mobile.css';
    .slide-enter-active, .slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
  transform: translateX(10.53vw);
}
.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 2s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 2s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.15)
  }

  to {
    transform: scale(1);
  }
}
</style>
